import React, { useState } from 'react';
import Sidebar from '../../components/Classroom/Sidebar';
import ClassroomPage from '../Classroom/ClassroomPage';
import ProfilePage from '../Profile/ProfilePage';
import '../../css/MainLayout.css';

const ProfileLayout = () => {
  const [activeSection, setActiveSection] = useState('profile');

  const renderSection = () => {
    switch (activeSection) {
      case 'profile':
        return <ProfilePage />;
      case 'classroom':
        return <ClassroomPage />;
      default:
        return <ProfilePage />;
    }
  };

  return (
    <div className="main-layout">
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} />
      <main className="content-area">
        {renderSection()}
      </main>
    </div>
  );
};

export default ProfileLayout;